<template>
    <div class="wrap-manage">
        <div class="main">
            <h2><p>{{title}}</p></h2>
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    components:{},
    props:{
        title:{
            type:String,
            default:''
        }
    }
}
</script>
<style lang="scss" scoped>
.wrap-manage {
    padding-bottom: 140px;
    .main { 
        @include Width;
        margin: 0 auto;
        margin-top: 20px;
        background-color: #fff;
        padding: 0 20px;
        h2 {
        line-height: 54px;
        height: 54px;
        color: #333333;
            p {
                border-bottom: 1px solid #ededed;
            }
        }   
    }  
}
</style>




